@import '@helsenorge/designsystem-react/scss/palette';

.zoom {
  background-color: $black;
  padding: 0;
  border: 0;
  width: 38px;
  height: 38px;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;

  &:hover {
    background-color: rgb(0 0 0 / 80%);
    outline: 1px solid $white;
  }

  &:focus {
    outline: 2px solid $white;
  }
}
